$('.teacher-slider a').on('click', function(e) {
	e.preventDefault();
	var href = $(this).attr('href');
	$('.teacher__item').hide();
	$(href).fadeIn();
});



//////////////////
// WEBPACK FOOTER
// ./js/components/scripts/slider-tabs.js
// module id = 24
// module chunks = 0